var map = {
	"./intl-en": [
		5265,
		265
	],
	"./intl-en.js": [
		5265,
		265
	],
	"./intl-fr": [
		1714,
		714
	],
	"./intl-fr.js": [
		1714,
		714
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8497;
module.exports = webpackAsyncContext;